import { useNavigate } from "react-router-dom";
import { routeTo } from "router";
import { useAppDispatch, useAppSelector } from "store";
import { sandboxActionCompleted, sandboxActionInvoked, selectCurrentUser } from "store/features";
import { CodeShareMetadata } from "types";
import { TemplateSelectionDialog } from "./TemplateSelectionDialog";
import { TrackedSandboxEvent, useTrackSandboxEvent } from "services/telemetry-service/telemetry";

export const CreateSandboxActionHandler = () => {
  const user = useAppSelector(selectCurrentUser);
  const sandboxUser = useAppSelector((state) => state.auth.sandboxUser);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const trackEvent = useTrackSandboxEvent<TrackedSandboxEvent>("Sandbox published");

  const onClose = () => {
    dispatch(sandboxActionCompleted());
  };

  const onConfirm = (sandbox: CodeShareMetadata) => {
    onClose();
    navigate(routeTo.sandbox({ userName: sandbox.username, sandboxName: sandbox.name }));
    trackEvent({ SandboxName: sandbox.name, SandboxUser: sandbox.username, SandboxUserId: sandbox.userId, SandboxId: sandbox.id })
  }

  if (!user) {
    dispatch(sandboxActionInvoked({ type: "signin-prompt" }));
    return null;
  }

  if (!sandboxUser) {
    dispatch(sandboxActionInvoked({ type: "set-username", args: { actionResumeType: "create" } }));
    return null;
  }

  return (
    <TemplateSelectionDialog onConfirm={onConfirm} onClose={onClose} />
  )
};
